import { useEffect } from "react";
import { SITE_NAME, SITE_URL, siteGraph } from "@/lib/schema";

export { faqSchema, serviceSchema, breadcrumbSchema, webPageSchema, siteGraph, businessNode } from "@/lib/schema";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function ensureSiteGraph() {
  if (document.getElementById("site-jsonld")) return;
  const el = document.createElement("script");
  el.type = "application/ld+json";
  el.id = "site-jsonld";
  el.textContent = JSON.stringify(siteGraph());
  document.head.appendChild(el);
}

// Per-page SEO: title, description, canonical (always cjbclean.com), OpenGraph/Twitter, robots, JSON-LD.
export function useSEO({ title, description, keywords, path, canonical, jsonLd, noindex = false }) {
  useEffect(() => {
    const url = SITE_URL + (canonical || path || window.location.pathname);
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertCanonical(url);
    ensureSiteGraph();

    let el = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = "page-jsonld";
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(jsonLd);
    } else if (el) {
      el.remove();
    }
    return () => {
      const e = document.getElementById("page-jsonld");
      if (e) e.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, keywords, path, canonical, noindex, JSON.stringify(jsonLd)]);
}
